import React, { useState, useEffect } from 'react';
import { Container, Modal, Form, Button } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
const Teachers = () => {
  const [showAddTeacherModal, setShowAddTeacherModal] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [update, setUpdate] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    contact: '',
    profilePictureFile: null,
    cv: null,
    username: '',
    institute: '',
    country: '',
    dateOfBirth: '',
    educationLevel: '',
    motivation: '',
    expertise: '',
  });

  useEffect(() => {
    fetchTeachers();
  }, []);

  const fetchTeachers = async () => {
    try {
      const response = await axios.get('https://backend.writerswright.com/api/v1/admin/getTeachers');
      setTeachers(response.data);
    } catch (error) {
      console.error('Error fetching teachers data:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const handleCloseAddTeacherModal = () => setShowAddTeacherModal(false);
  const handleShowAddTeacherModal = () => setShowAddTeacherModal(true);

  const handleSubmitAddTeacher = async (e) => {
    e.preventDefault();
    try {
      if (update) {
        const form = new FormData();
        for (const key in formData) {
          form.append(key, formData[key]);
        }

        const response = await axios.put(`https://backend.writerswright.com/api/v1/admin/updateTeacher?Id=${Cookies.get('uId')}`, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(response.data); // Handle success message if needed

      } else {
        const form = new FormData();
        for (const key in formData) {
          form.append(key, formData[key]);
        }

        const response = await axios.post('https://backend.writerswright.com/api/v1/teacher/register', form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(response.data); // Handle success message if needed

      }

      setFormData({
        name: '',
        surname: '',
        email: '',
        contact: '',
        profilePictureFile: null,
        cv: null,
        username: '',
        institute: '',
        country: '',
        dateOfBirth: '',
        educationLevel: '',
        motivation: '',
        expertise: '',
      })
      fetchTeachers(); // Refresh the teachers list
      handleCloseAddTeacherModal(); // Close the modal after successful submission
    } catch (error) {
      console.error('Error submitting add teacher form:', error);
    }
  };

  const handleDeleteTeacher = async (teacherId) => {
    try {
      const response = await axios.delete(`https://backend.writerswright.com/api/v1/admin/deleteTeacher?Id=${teacherId}`);
      console.log(response.data); // Handle success message if needed
      fetchTeachers(); // Refresh the teachers list
    } catch (error) {
      console.error('Error deleting teacher:', error);
    }
  };

  const handleStatusUpdate = async (teacherId, status) => {
    try {
      const response = await axios.get(`https://backend.writerswright.com/api/v1/admin/approveteacher?id=${teacherId}&status=${status}`);
      console.log(response.data); // Handle success message if needed
      fetchTeachers(); // Refresh the teachers list
    } catch (error) {
      console.error(`Error updating teacher status to ${status}:`, error);
    }
  };

  const navigate = useNavigate();

  const navigateToStudentsDetails = () => {
    navigate('/admin-portal/teachers-details');
  };



  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3 alltitles">
        <h4 className='titleone'>Teachers</h4>
        <Button className='button-37' onClick={() => {
          setUpdate(false); setFormData({
            name: '',
            surname: '',
            email: '',
            contact: '',
            profilePictureFile: null,
            cv: null,
            username: '',
            institute: '',
            country: '',
            dateOfBirth: '',
            educationLevel: '',
            motivation: '',
            expertise: '',
          }); handleShowAddTeacherModal();
        }}>Add Teacher</Button>
      </div>
      <div className='tables'>
        <MDBTable bordered>
          <MDBTableHead>
            <tr>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Sr</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Name</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Email</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Contact</th>
              {/* <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Assigned Essays</th> */}
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Details</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Approvals</th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className='text'>Actions</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {teachers.map((teacher, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{teacher.Name}</td>
                <td>{teacher.Email}</td>
                <td>{teacher.Contact}</td>
                {/* <td>
                  <a href={`https://backend.writerswright.com/${teacher.assignedEssays}`} download="download.pdf">Download PDF</a>
                </td> */}
                <td>
                  <button onClick={() => { Cookies.set('uId', teacher.userId); navigateToStudentsDetails(); }} style={{ color: "black", background: "none", border: "none", textDecoration: "underline" }}>View More</button>
                </td>
                <td>
                  {teacher.Status === 'Approved' ? (<span style={{ color: 'green' }}>Approved</span>) : (
                    <div>
                      {teacher.Status === 'Rejected' ? (<span style={{ color: 'red' }}>Rejected</span>) : (
                        <div>
                          <Link onClick={() => handleStatusUpdate(teacher.Id, 'Approved')} style={{ marginRight: "10px", color: "green" }}>Approve</Link>
                          <Link onClick={() => handleStatusUpdate(teacher.Id, 'Rejected')} style={{ color: "red" }}>Reject</Link>
                        </div>
                      )}
                    </div>
                  )}
                </td>
                <td>
                  <FaEdit style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => {
                    setUpdate(true);
                    Cookies.set('uId', teacher.Id);
                    setFormData({
                      name: teacher.Name,
                      surname: teacher.Surname,
                      email: teacher.Email,
                      contact: teacher.Contact,
                      profilePictureFile: null,
                      cv: null,
                      username: teacher.Username,
                      institute: teacher.Institute,
                      country: teacher.Country,
                      dateOfBirth: teacher.DateOfBirth,
                      educationLevel: teacher.EducationLevel,
                      motivation: teacher.otivation,
                      expertise: teacher.Expertise,
                    }); handleShowAddTeacherModal();
                  }} />
                  <FaTrash style={{ cursor: 'pointer' }} onClick={() => handleDeleteTeacher(teacher.userId)} />
                </td>
              </tr>
            ))}
          </MDBTableBody>
        </MDBTable>
      </div>

      <Modal show={showAddTeacherModal} onHide={handleCloseAddTeacherModal}>
        <Modal.Header closeButton>
          {update ? (<Modal.Title>Update Teacher</Modal.Title>) : (<Modal.Title>Add Teacher</Modal.Title>)}
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitAddTeacher}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formSurname">
              <Form.Label>Surname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter surname"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formContact">
              <Form.Label>Contact</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact number"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formProfilePicture">
              <Form.Label>Profile Picture</Form.Label>
              <Form.Control
                type="file"
                name="profilePictureFile"
                onChange={handleFileChange}
              />
            </Form.Group>

            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formInstitute">
              <Form.Label>Institute</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter institute"
                name="institute"
                value={formData.institute}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formCountry">
              <Form.Label>Country</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter country"
                name="country"
                value={formData.country}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formDOB">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formEducationLevel">
              <Form.Label>Education Level</Form.Label>
              <Form.Control
                as="select"
                name="educationLevel"
                value={formData.educationLevel}
                onChange={handleChange}
              >
                <option value="">Select Education Level</option>
                <option value="High School">High School</option>
                <option value="Undergraduate">Undergraduate</option>
                <option value="Postgraduate">Postgraduate</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formMotivation">
              <Form.Label>Motivation</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter motivation"
                name="motivation"
                value={formData.motivation}
                onChange={handleChange}
              />
            </Form.Group>

            {update ? (null) : (<Form.Group controlId="formExpertise">
              <Form.Label>Expertise</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter expertise"
                name="expertise"
                value={formData.expertise}
                onChange={handleChange}
              />
            </Form.Group>)}

            {update ? (null) : (<Form.Group controlId="formCV">
              <Form.Label>CV</Form.Label>
              <Form.Control
                type="file"
                name="cv"
                onChange={handleFileChange}
              />
            </Form.Group>)}

            <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseAddTeacherModal}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Teachers;
